import { API, graphqlOperation } from 'aws-amplify';
import { FLEXICO_TEMPLATE_KEYS } from 'src/Ateam-BI/FlexiCo/Constants';
import { getQueryInput } from 'src/Ateam-BI/Templates/Utils/AppActivityUtils';
import { configureFlexicoAppSync, configureGenericAppSync, configurePlusAppsync } from 'src/context/AuthContextUtility';
import { executeQuerySync } from './AppSyncPlusAPIs';


export const loadFlexicoTemplates = async(appId, onSuccess, onFailure) => {
    var mQryFlexico = `
    query MyQuery {
      listFlexicoTemplatesRDS(app_id: "${appId}") {
        label
        app_id
        approval_days
        approval_required
        created_by
        created_time_stamp
        description
        approvers {
          alias
          column_index
          type
        }
        status
        parameters {
          field_id
          field_type
          field_values
          label
          display_name
        }
        file_types
        flex_id
        group_id
        group_name
        last_updated_by
        last_updated_time_stamp
        next_step
        step_function_name
        template_name
        uploaders {
          alias
          type
        }
      }
    }  
  `;

    executeQuery(mQryFlexico, onSuccess, onFailure)
}


export const listFlexicoTemplatesWithTracks = async(appId, quarter, onSuccess, onFailure) => {
  var mQryFlexico = `
  query MyQuery {
    listFlexicoTemplatesWithTracksRDS(app_id: "${appId}", quarter: "${quarter}") {
      label
      app_id
      mapping_id
      approval_days
      approval_required
      created_by
      created_time_stamp
      description
      approvers {
        alias
        column_index
        type
      }
      ripple_approvers {
        alias
        column_index
        type
      }
      status
      parameters {
        field_id
        field_type
        field_values
        label
        display_name
      }
      file_types
      flex_id
      group_id
      group_name
      last_updated_by
      last_updated_time_stamp
      next_step
      step_function_name
      template_name
      uploaders {
        alias
        type
      }
      current_status
      overall_status
      custom_attributes {
        sub_type
        attribute
        attribute_type
      }
    }
  }  
`;
  // console.log(mQryFlexico)
  executeQuery(mQryFlexico, onSuccess, onFailure)
}


const getListQuery = (appId,flexId,limit, nextToken) => {
var mQryFlexico = `query MyQuery {
        listFlexicoTransactionsByFlexId(appId: "${appId}", flexId: "${flexId}" ,first: ${limit} ${getNextTokenQuery(nextToken)}) {
          nextToken
          items {
            appId
          bucketName
          createdTimestamp
          errorMessage
          filePath
          fileId
          fileExt
          flexId
          jobStartTime
          jobStatusModificationTimestamp
          lastUpdatedTimestamp
          status
          notice
          stepInstanceID
          stepToken
          uploadedTimestamp
          uploadedBy
          parameters
          approvalModificationTime
          approvalRequestedTime
          approvalStatus
          approvedBy
          approvalId
          outputResultsS3
          outputResults
          rippleApprovalStatus
          rippleApprovalId
          reviewStatus
          reviewId
          }
        }
      }
      `;
      return mQryFlexico
}


export const listFlexicoTransactionsByFlexIdAll = async(appId,flexId,limit, nextToken, onSuccess, onFailure) => {
    var mQryFlexico = getListQuery(appId,flexId,limit, nextToken)

    let results = []
    let response =  await executeQuerySync(mQryFlexico)
    results = [...results, ...response.data.listFlexicoTransactionsByFlexId.items]
    while(response.data.listFlexicoTransactionsByFlexId.nextToken){
        mQryFlexico = getListQuery(appId,flexId,limit, response.data.listFlexicoTransactionsByFlexId.nextToken)
        response =  await executeQuerySync(mQryFlexico)
        results = [...results, ...response.data.listFlexicoTransactionsByFlexId.items]
    }
    onSuccess(results)
}


export const getFlexicoTemplate = (flexId, onSuccess, onFailure) => {
    var mQryFlexico = `
    query MyQuery {
        getFlexicoTemplateRDS(flex_id: "${flexId}") {
          app_id
          mapping_id
          approval_days
          approval_required
          approvers {
            alias
            column_index
            type
          }
          created_by
          created_time_stamp
          critical_data
          description
          file_types
          group_id
          group_name
          label
          last_updated_by
          last_updated_time_stamp
          next_step
          flex_id
          parameters {
            field_id
            field_type
            field_values
            label
            display_name
            info
            source_database
            is_mandatory
            is_hidden
            display_index
          }
          sox_approved
          sox_evidence
            trigger_type
            upload_mandatory
          status
          step_function_name
          template_name
          uploaders {
            alias
            type
          }
          custom_attributes {
            sub_type
            attribute
            attribute_type
          }
        }
      }
       
  `;

    executeQuery(mQryFlexico, onSuccess, onFailure)
}

export const deleteFlexicoTemplate = async(flexId, onSuccess, onFailure) => {
    var mQryFlexico = `
    mutation MyMutation {
        deleteFlexicoTemplate(input: {flex_id: "${flexId}"}) {
          message
        }
      }
  `;

    executeQuery(mQryFlexico, onSuccess, onFailure)
}

const cleanForMutation = (data) => {
    if (data?.hasOwnProperty(FLEXICO_TEMPLATE_KEYS.parameters)) {
        let cleanedParams = []
        for (let i = 0; i < data?.[FLEXICO_TEMPLATE_KEYS.parameters]?.length; i++) {
            let param = data[FLEXICO_TEMPLATE_KEYS.parameters][i]
            if (param?.hasOwnProperty('field_tokens') ) {
                delete param['field_tokens']
            }
            if (param?.hasOwnProperty('limit') ) {
                delete param['limit']
            }
            if (param?.hasOwnProperty('typed_value')) {
                delete param['typed_value']
            }
            if (param?.hasOwnProperty('show_verify_loader') ) {
              delete param['show_verify_loader']
          }
          if (param?.hasOwnProperty('show_verification_message')) {
              delete param['show_verification_message']
          }if (param?.hasOwnProperty('preferences')) {
            delete param['preferences']
        }
            cleanedParams.push(param)
        }
        data[FLEXICO_TEMPLATE_KEYS.parameters] = cleanedParams
    }
    return data
}
export const createFlexicoTemplate = (data, onSuccess, onFailure) => {
    data = cleanForMutation(data)
    var mQryFlexico = `mutation MyMutation {
        createFlexicoTemplate(input: {${getQueryInput(data, [FLEXICO_TEMPLATE_KEYS.last_updated_time_stamp, FLEXICO_TEMPLATE_KEYS.created_time_stamp, FLEXICO_TEMPLATE_KEYS.group_name])}}
        ) {
            app_id
            mapping_id
            approval_days
            approval_required
            approvers {
              alias
              column_index
              type
            }
            created_by
            created_time_stamp
            critical_data
            description
            file_types
            flex_id
            group_id
            label
            last_updated_by
            last_updated_time_stamp
            next_step
            sox_approved
            sox_evidence
            trigger_type
            upload_mandatory
            status
            step_function_name
            template_name
            uploaders {
              alias
              type
            }
            parameters {
              field_id
              field_type
              field_values
              label
              display_name
              info
              source_database
              is_mandatory
              is_hidden
              display_index
            }
        }
      } 
  `;

      // console.log(mQryFlexico)
    executeQuery(mQryFlexico, onSuccess, onFailure)

}

export const updateFlexicoTemplate = (data, onSuccess, onFailure) => {
    data = cleanForMutation(data)
    var mQryFlexico = `mutation MyMutation {
        updateFlexicoTemplate(input: {${getQueryInput(data, [FLEXICO_TEMPLATE_KEYS.last_updated_time_stamp, FLEXICO_TEMPLATE_KEYS.created_time_stamp, FLEXICO_TEMPLATE_KEYS.created_by, FLEXICO_TEMPLATE_KEYS.group_name])}}
        ) {
            app_id
            approval_days
            approval_required
            approvers {
              alias
              column_index
              type
            }
            created_by
            created_time_stamp
            critical_data
            description
            file_types
            flex_id
            group_id
            label
            last_updated_by
            last_updated_time_stamp
            next_step
            sox_approved
            sox_evidence
            trigger_type
            upload_mandatory
            status
            step_function_name
            template_name
            uploaders {
              alias
              type
            }
            parameters {
              field_id
              field_type
              field_values
              label
              display_name
              info
              source_database
              is_mandatory
              is_hidden
              display_index
            }
            custom_attributes {
              sub_type
              attribute
              attribute_type
            }
        }
      } 
  `;

      // console.log(mQryFlexico)
    executeQuery(mQryFlexico, onSuccess, onFailure)

}

export const createFlexicoTransaction = (data, onSuccess, onFailure) => {
    var mQryFlexico = `mutation MyMutation {
        createFlexicoTransaction(input: {${getQueryInput(data, [])}}) {
          appId
          bucketName
          createdTimestamp
          errorMessage
          filePath
          fileId
          fileExt
          flexId
          jobStartTime
          jobStatusModificationTimestamp
          lastUpdatedTimestamp
          status
          stepInstanceID
          stepToken
          uploadedTimestamp
          uploadedBy
          parameters
        }
      }
      `;

    //   console.log(mQryFlexico)
    executeQuery(mQryFlexico, onSuccess, onFailure)

}

export const getNextTokenQuery = (nextToken) => {
    if (nextToken) {
      return `, after: "${nextToken}"`
    } else {
      return ''
    }
  
  }
export const listFlexicoTransactionsByFlexId = async (appId,flexId,limit, nextToken, onSuccess, onFailure) => {
    var mQryFlexico = `query MyQuery {
        listFlexicoTransactionsByFlexId(appId: "${appId}", flexId: "${flexId}" ,first: ${limit} ${getNextTokenQuery(nextToken)}) {
          nextToken
          items {
            appId
          bucketName
          createdTimestamp
          errorMessage
          filePath
          fileId
          fileExt
          flexId
          jobStartTime
          jobStatusModificationTimestamp
          lastUpdatedTimestamp
          status
          notice
          stepInstanceID
          stepToken
          uploadedTimestamp
          uploadedBy
          parameters
          approvalModificationTime
          approvalRequestedTime
          approvalStatus
          approvedBy
          approvalId
          outputResultsS3
          outputResults
          rippleApprovalStatus
          rippleApprovalId
          reviewStatus
          reviewId
          }
        }
      }
      `;

    //   console.log(mQryFlexico)
    executeQuery(mQryFlexico, onSuccess, onFailure)

}

export const getFlexicoTransaction = (fileId, onSuccess, onFailure) => {
  let qry = `query MyQuery {
    getFlexicoTransaction(fileId: "${fileId}") {
    fileExt
    errorMessage
    fileId
    filePath
    flexId
    jobStartTime
    jobStatusModificationTimestamp
    lastUpdatedTimestamp
    outputResultsS3
    outputResults
    parameters
    plainParameters
    quarter
    status
    uploadedBy
    uploadedTimestamp
    uploaders
    createdTimestamp
    bucketName
    approvers
    approvedBy
    approvalStatus
    approvalRequestedTime
    approvalModificationTime
    approvalId
    appId
    rippleApprovalStatus
    rippleApprovalId
    reviewStatus
    reviewId
    }
  }
  `
  // console.log(qry)
  executeQuery(qry, onSuccess, onFailure)
}

export const verifyDynamicQuery = (source, query, onSuccess, onFailure) => {
  let qry = `query MyQuery {
  verifyDynamicQuery(query: "${query.replace(/\s+/g, ' ')}", source: "${source}")
}
  `
  // console.log(qry)
  executeQuery(qry, onSuccess, onFailure)
}

export const fetchDynamicQueryValues = (field_id, dependency, onSuccess, onFailure) => {
  let qry=`query MyQuery {
  fetchDynamicQueryValues(field_id: "${field_id}" 
  ${dependency ? `,dependency:${JSON.stringify(JSON.stringify(dependency))}` : ''})
}`
// console.log(qry)
executeQuery(qry, onSuccess, onFailure)
}

export const getDynamicTablesForFlexico = async (flexId, onSuccess, onFailure) => {
  var mQryFlexico = `
    query MyQuery {
      getDynamicTablesForFlexico(flex_id: "${flexId}")
    }
  `;

  executeQuery(mQryFlexico, onSuccess, onFailure)
}

export const triggerDynamicTableRefresh = async (input, requestSource, onSuccess, onFailure) => {
  var mQryFlexico = `
    mutation MyMutation {
      triggerDynamicTableRefresh(input: ${JSON.stringify(JSON.stringify(input))}, requestSource: "${requestSource}")
    }
  `;
  // console.log(mQryFlexico)
  executeQuery(mQryFlexico, onSuccess, onFailure)
}

export const getTableSyncMemory = async (input, source, onSuccess, onFailure) => {
  var mQryFlexico = `
    query MyQuery {
      getTableSyncMemory(glueTableNames: ${JSON.stringify(input)}, sources: ${JSON.stringify(source)})
    }
  `;
  // console.log(mQryFlexico)
  executeQuery(mQryFlexico, onSuccess, onFailure)
}

export const executeQuery = async (mQry, onSuccess, onFailure, maxRetries = 3, delayMs = 1000) => {
    let retryCount = 0;

    const executeWithRetry = async () => {
        try {
            await configurePlusAppsync();
            const result = await API.graphql(graphqlOperation(mQry));
            if (onSuccess) {
                onSuccess(result);
                await configureGenericAppSync();
            }
            return result;
        } catch (error) {
            if (retryCount < maxRetries) {
                retryCount++;
                await new Promise(resolve => setTimeout(resolve, delayMs * retryCount)); // Exponential backoff
                return executeWithRetry();
            } else {
                await configureGenericAppSync();
                if (onFailure) {
                    onFailure(error);
                }
                throw error;
            }
        }
    };

    return executeWithRetry();
};